// extracted by mini-css-extract-plugin
export default {"numberInput":"NumberInput_numberInput__oVGO5","label":"NumberInput_label__RbACQ","separator":"NumberInput_separator__lTYcl"};